import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Navigation.css';

const Navigation: React.FC = () => {
  const location = useLocation();

  return (
    <nav className="navigation">
      <div className="nav-container">
        <div className="nav-links">
          <Link
            to="/"
            className={`nav-link ${location.pathname === '/' ? 'active' : ''}`}
          >
            🏠 首页
          </Link>
          <Link
            to="/create"
            className={`nav-link ${location.pathname === '/create' ? 'active' : ''}`}
          >
            💰 发红包
          </Link>
          <Link
            to="/claim"
            className={`nav-link ${location.pathname === '/claim' ? 'active' : ''}`}
          >
            🎁 抢红包
          </Link>
        </div>
      </div>
    </nav>
  );
};

export default Navigation;

